// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KQllC","buttons":"Footer_buttons__28TJ4"};